import { SECTION_CATALOG } from "./SectionCatalog";
import { normalizeEntityType } from "./SectionConfig";
import { normalizeRelationshipStatus } from "../../utils/relationshipStatus";

/**
 * Section keys where the edited entity is the relationship TARGET (incoming edges).
 * Must stay aligned with `incomingRelationshipSections` in EntityForm `createRelationships`.
 */
export const INCOMING_RELATIONSHIP_SECTION_KEYS = new Set([
  "interface_provided_by_app",
  "interface_consumed_by_app",
  "interface_affected_by_initiative",
  "data_object_transferred_by_interface",
  "data_object_affected_by_initiative",
  "data_object_crud_by_application",
  "technology_component_used_by_interface",
  "technology_component_used_by_application",
  "technology_component_offered_by_provider",
  "it_provided_by_provider_reverse",
  "technology_component_owned_by_organization",
  "technology_component_affected_by_initiative",
  "platform_implemented_by_it_components",
  "organization_uses_application_reverse",
  "initiative_affects_application_reverse",
  "platform_runs_application_reverse",
  "initiative_affects_business_context_reverse",
  "application_supports_business_context_reverse",
  "business_capability_linked_to_business_context_reverse",
  "organization_owns_business_context_reverse",
  "initiative_improves_business_capability_reverse",
  "objective_improves_business_capability_reverse",
  "application_supports_business_capability_reverse",
  "business_context_linked_to_business_capability_reverse",
  "initiative_affects_platform_reverse",
  "objective_supported_by_initiative",
  "objective_supported_by_platform",
  "objective_owned_by_organization",
  "organization_owns_initiative_reverse",
  "provider_supports_initiative_reverse",
]);

/**
 * Build `create` payloads for POST /api/relationships/batch (same shape as EntityForm `pushSectionCreates`).
 */
export function buildRelationshipCreatesForSection({
  sectionKey,
  currentEntityId,
  relatedEntities,
  catalogEntityType,
}) {
  const incoming = INCOMING_RELATIONSHIP_SECTION_KEYS.has(sectionKey);
  const defs =
    SECTION_CATALOG[normalizeEntityType(catalogEntityType || "")] || [];
  const def = defs.find((d) => d.key === sectionKey);
  const relationshipType =
    (def?.relationshipTypes && def.relationshipTypes[0]) || "uses";
  const creates = [];
  for (const relatedEntity of relatedEntities || []) {
    if (!relatedEntity?.id || !currentEntityId) continue;
    creates.push({
      source_entity_id: incoming ? relatedEntity.id : currentEntityId,
      target_entity_id: incoming ? currentEntityId : relatedEntity.id,
      type: relationshipType,
      description: relatedEntity.description || "",
      active_from: relatedEntity.activeFrom || null,
      active_until: relatedEntity.activeUntil || null,
      status: relatedEntity.status
        ? normalizeRelationshipStatus(relatedEntity.status)
        : "Proposed",
      confidence: 0.9,
    });
  }
  return creates;
}
